<template>
    <div class="fixed inset-y-0 z-50 w-full" v-show="isActiveContainer">
        <transition name="fade" v-on:after-leave="afterLeaveBG" mode="out-in">
            <div
                class="absolute w-full h-screen bg-black bg-opacity-25"
                @click.self="isActive = false"
                v-show="isActiveBG"
            >
                <button
                    @click="isActive = false"
                    type="button"
                    class="flex items-center justify-center w-10 h-10 mt-8 ml-4 transition-colors duration-200 bg-white rounded-full md:hidden hover:text-dark text-gray-2 focus:outline-none focus:shadow-outline"
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>
        </transition>

        <transition name="slide-fade" v-on:leave="leave">
            <div
                class="absolute right-0 flex flex-col w-full ml-auto hover-menu h-screen-fix"
                @mouseenter="isActive = true"
                @mouseleave="isActive = false"
                v-show="isActive"
            >
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isActive: false,
            isActiveBG: false,
            isActiveContainer: false
        };
    },

    created() {
        Event.$on("hover-menu:open", () => {
            this.isActive = true;
            this.isActiveBG = true;
            this.isActiveContainer = true;
        });
    },

    methods: {
        leave() {
            this.isActiveBG = false;
        },

        afterLeaveBG() {
            this.isActiveContainer = false;
        }
    }
};
</script>
